<template>
    <b-card no-body>
        <div class="row px-1 pt-1 align-items-end">
            <div class="col-md-2 mb-1">
                <label class="form-label">Tarih Aralığı</label>
                <v-date-picker v-model="date" range placeholder="Tarih Aralığı"></v-date-picker>        
            </div>
            <div class="col-md-4 mb-1">
                <label class="form-label">Bitiş Firma</label>
                <v-select-list v-model="selectedTargetCaris" :options="targetCariList" label="CARI_ISIM" v-on:search="getTargetCariList" placeholder="Bitiş Firma" :loading="targetCariLoading" multiple :close-on-select="false"></v-select-list>
            </div>
            <div class="col-md-4 mb-1">
                <label class="form-label">Stok</label>
                <v-select-list v-model="selectedStoks" :options="stoks" label="Name" placeholder="Stok" :loading="stokLoading" multiple :close-on-select="false"></v-select-list>
            </div>
            <div class="col-auto mb-1">
                <v-executer :loading="filterLoading" :action="filter">Filtrele</v-executer>
            </div>
            <div class="col-auto mb-1">
                <v-executer :loading="exporting" variant="success" :action="downloadExcel">Excel</v-executer>
            </div>
            <div class="col-auto mb-1">
                <v-executer :loading="exportingAll" variant="outline-success" :action="downloadAllExcel">Tüm Taşımaları İndir</v-executer>
            </div>
        </div>
        <div class="px-1 pb-1">
            <table class="table table-sm table-bordered bordered-header align-middle compact-report mb-0">
                <colgroup>
                    <col style="width:7%">   <!-- Grup Kodu -->
                    <col style="width:12%">  <!-- Grup Adı -->
                    <col style="width:7%">   <!-- Stok Kodu -->
                    <col style="width:12%">  <!-- Stok Adı -->
                    <col style="width:13%">  <!-- Cari -->
                    <col style="width:5%">   <!-- Çelemli Adet -->
                    <col style="width:7%">   <!-- Çelemli Tonaj -->
                    <col style="width:5%">   <!-- Narlı Adet -->
                    <col style="width:7%">   <!-- Narlı Tonaj -->
                    <col style="width:5%">   <!-- Çukurova Adet -->
                    <col style="width:7%">   <!-- Çukurova Tonaj -->
                    <col style="width:5.5%"> <!-- Top. Adet -->
                    <col style="width:7.5%"> <!-- Top. Tonaj -->
                </colgroup>
                <thead>
                    <tr>
                        <th rowspan="2" class="align-middle">Grup Kodu</th>
                        <th rowspan="2" class="align-middle">Grup Adı</th>
                        <th rowspan="2" class="align-middle">Stok Kodu</th>
                        <th rowspan="2" class="align-middle">Stok Adı</th>
                        <th rowspan="2" class="align-middle">Cari</th>
                        <th colspan="2" class="text-center">Çelemli</th>
                        <th colspan="2" class="text-center">Narlı</th>
                        <th colspan="2" class="text-center">Çukurova</th>
                        <th rowspan="2" class="align-middle text-right num">Top. Adet</th>
                        <th rowspan="2" class="align-middle text-right num">Top. Tonaj</th>
                    </tr>
                    <tr>
                        <th class="text-right num">Adet</th>
                        <th class="text-right num">Tonaj</th>
                        <th class="text-right num">Adet</th>
                        <th class="text-right num">Tonaj</th>
                        <th class="text-right num">Adet</th>
                        <th class="text-right num">Tonaj</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(d,i) in data">
                        <tr v-if="!d.Stats && !d.GroupStats && !d.GrandStats" :key="i">
                            <td v-if="d.GroupIsFirst" :rowspan="d.GroupRowSpan">{{ d.GroupCode }}</td>
                            <td v-if="d.GroupIsFirst" :rowspan="d.GroupRowSpan">{{ d.GroupName }}</td>
                            <td v-if="d.StokIsFirst" :rowspan="d.StokRowSpan">{{ d.StokKodu }}</td>
                            <td v-if="d.StokIsFirst" :rowspan="d.StokRowSpan">{{ d.StokAdi }}</td>
                            <td>{{ d.Cari }}</td>
                            <td class="text-right num">{{ d.Celemli.TasimaSayisi }}</td>
                            <td class="text-right num">{{ fmt(d.Celemli.TasimaToplamTonaj) }}</td>
                            <td class="text-right num">{{ d.Narli.TasimaSayisi }}</td>
                            <td class="text-right num">{{ fmt(d.Narli.TasimaToplamTonaj) }}</td>
                            <td class="text-right num">{{ d.Cukurova.TasimaSayisi }}</td>
                            <td class="text-right num">{{ fmt(d.Cukurova.TasimaToplamTonaj) }}</td>
                            <td class="text-right num">{{ d.TasimaSayisi }}</td>
                            <td class="text-right num">{{ fmt(d.TasimaToplamTonaj) }}</td>
                        </tr>
                        <tr v-if="d.Stats" :key="i" class="bg-light-secondary">
                            <td class="text-right text-secondary font-weight-bolder">TOPLAM</td>
                            <td class="text-right text-secondary font-weight-bolder num">{{ d.CelemliTotalCount }}</td>
                            <td class="text-right text-secondary font-weight-bolder num">{{ fmt(d.CelemliTotalTonnage) }}</td>
                            <td class="text-right text-secondary font-weight-bolder num">{{ d.NarliTotalCount }}</td>
                            <td class="text-right text-secondary font-weight-bolder num">{{ fmt(d.NarliTotalTonnage) }}</td>
                            <td class="text-right text-secondary font-weight-bolder num">{{ d.CukurovaTotalCount }}</td>
                            <td class="text-right text-secondary font-weight-bolder num">{{ fmt(d.CukurovaTotalTonnage) }}</td>
                            <td class="text-right text-secondary font-weight-bolder num">{{ d.TotalCountTasimaSayisi }}</td>
                            <td class="text-right text-secondary font-weight-bolder num">{{ fmt(d.TotalTonnage) }}</td>
                        </tr>
                        <tr v-if="d.GroupStats" :key="i" class="bg-light-warning font-weight-bolder">
                            <td colspan="5" class="text-right">GRUP TOPLAMI · {{ d.GroupName }}</td>
                            <td class="text-right num">{{ d.CelemliTotalCount }}</td>
                            <td class="text-right num">{{ fmt(d.CelemliTotalTonnage) }}</td>
                            <td class="text-right num">{{ d.NarliTotalCount }}</td>
                            <td class="text-right num">{{ fmt(d.NarliTotalTonnage) }}</td>
                            <td class="text-right num">{{ d.CukurovaTotalCount }}</td>
                            <td class="text-right num">{{ fmt(d.CukurovaTotalTonnage) }}</td>
                            <td class="text-right num">{{ d.TotalCountTasimaSayisi }}</td>
                            <td class="text-right num">{{ fmt(d.TotalTonnage) }}</td>
                        </tr>
                        <tr v-if="d.GrandStats" :key="i" class="bg-primary text-white font-weight-bolder">
                            <td colspan="5" class="text-right">GENEL TOPLAM</td>
                            <td class="text-right num">{{ d.CelemliTotalCount }}</td>
                            <td class="text-right num">{{ fmt(d.CelemliTotalTonnage) }}</td>
                            <td class="text-right num">{{ d.NarliTotalCount }}</td>
                            <td class="text-right num">{{ fmt(d.NarliTotalTonnage) }}</td>
                            <td class="text-right num">{{ d.CukurovaTotalCount }}</td>
                            <td class="text-right num">{{ fmt(d.CukurovaTotalTonnage) }}</td>
                            <td class="text-right num">{{ d.TotalCountTasimaSayisi }}</td>
                            <td class="text-right num">{{ fmt(d.TotalTonnage) }}</td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue';
import { NetsisApi } from '@/api/netsis'
import { MaterialApi } from '@/api/material'
import moment from 'moment'
import Additional from '@/utilities/additional'

export default {
    components:{
        BCard
    },
    data(){
        return {
            queryData:{
                StartDate: moment().startOf('month').format('YYYY-MM-DD'),
                EndDate:moment().endOf('month').format("YYYY-MM-DD"),
                CariCode:null,
                BranchCode:null,
                RegionCode:null
            },
            selectedTargetCaris:[],
            selectedStoks:[],
            targetCariList:[],
            targetCariLoading:false,
            stoks:[],
            stokLoading:false,
            filterLoading:false,
            sefers:[],
            exporting:false,
            exportingAll:false,
        }
    },
    mounted(){
        this.getStoks()
    },
    methods:{
        getTargetCariList(searchKey){
            if(searchKey){
                this.targetCariLoading = true
                NetsisApi.CariList(searchKey).then(res => {
                    this.targetCariList = res.data.Data
                    this.targetCariLoading = false
                }).catch(err=> {
                    console.log(err)
                    this.targetCariLoading = false
                })
            }
        },
        getStoks(){
            this.stokLoading = true
            MaterialApi.List().then(res => {
                this.stoks = res.data.Data
                this.stokLoading = false
            }).catch(err=> {
                console.log(err)
                this.stokLoading = false
            })
        },
        filter(){
            this.filterLoading = true
            NetsisApi.GetSeferListReport(this.payload).then(res => {
                if(!res.data.Success){
                    this.$result(res)
                }else{
                    this.sefers = res.data.Data
                }
                this.filterLoading = false
            }).catch(err=> {
                console.log(err)
                this.filterLoading = false
            })
        },
        downloadExcel(){
            this.exporting = true
            NetsisApi.GetSeferListReportExcel(this.payload).then(res=>{
                this.exporting = false
                Additional.DownloadFile(res.data, `Sefer Raporu - ${this.queryData.StartDate} - ${this.queryData.EndDate}.xlsx`)
            }).catch(err => {
                this.exporting = false
            })
        },
        downloadAllExcel(){
            this.exportingAll = true
            NetsisApi.GetSeferListAllExcel(this.payload).then(res=>{
                this.exportingAll = false
                Additional.DownloadFile(res.data, `Tüm Taşımalar - ${this.queryData.StartDate} - ${this.queryData.EndDate}.xlsx`)
            }).catch(err => {
                this.exportingAll = false
            })
        },
        // Backend sube bazli tonajlari tr-TR formatli string olarak donuyor ("1.053,92").
        // Number() bunu NaN yaptigi icin dip toplamlar 0 cikiyordu; once sayiya cevriliyor.
        toNum(value){
            if(value === null || value === undefined || value === '') return 0
            if(typeof value === 'number') return isNaN(value) ? 0 : value
            let s = String(value).trim().replace(/\s/g,'')
            const hasComma = s.includes(',')
            const hasDot = s.includes('.')
            let decSep = null
            if(hasComma && hasDot){
                // iki ayrac da varsa sondaki ondalik ayracidir
                decSep = s.lastIndexOf(',') > s.lastIndexOf('.') ? ',' : '.'
            }else if(hasComma || hasDot){
                const sep = hasComma ? ',' : '.'
                const parts = s.split(sep)
                // birden fazla ayrac ya da 3 haneli son parca => binlik ayraci ("1.053")
                if(parts.length > 2 || parts[parts.length-1].length === 3) s = parts.join('')
                else decSep = sep
            }
            if(decSep){
                const groupSep = decSep === ',' ? '.' : ','
                s = s.split(groupSep).join('').replace(decSep,'.')
            }
            const n = Number(s)
            return isNaN(n) ? 0 : n
        },
        fmt(value){
            if(value === null || value === undefined || value === '') return ''
            return this.toNum(value).toLocaleString('tr-TR',{minimumFractionDigits:2,maximumFractionDigits:2})
        },
        getMaxCariCount(s){
            return s.SubItems.map(r => r.ReportItem.map(rr => rr.ReportItem.length )).reduce((s,i) => s += Number(i),0)
        },
        getStokMaxCariCount(st){
            return Math.max(...st.ReportItem.map(r => r.ReportItem.length),1)
        }
    },
    computed:{
        data(){
            const getStats = (key,stats = {}) => {
                const k = Object.keys(stats).find(kk => Additional.ToEng(kk).toLowerCase().includes(Additional.ToEng(key).toLowerCase()))
                return stats[k] || {TasimaToplamTonaj:0,TasimaSayisi:0}
            }
            // Toplam biriktirici: stok (ri) toplamlarını grup ve genel seviyeye toplar
            const newAcc = () => ({
                CelemliTotalCount:0, CelemliTotalTonnage:0,
                NarliTotalCount:0, NarliTotalTonnage:0,
                CukurovaTotalCount:0, CukurovaTotalTonnage:0,
                TotalCountTasimaSayisi:0, TotalTonnage:0,
            })
            const num = v => this.toNum(v)
            const addAcc = (acc,ri) => {
                acc.CelemliTotalCount      += num(ri.CelemliTotalCount)
                acc.CelemliTotalTonnage    += num(ri.CelemliTotalTonnage)
                acc.NarliTotalCount        += num(ri.NarliTotalCount)
                acc.NarliTotalTonnage      += num(ri.NarliTotalTonnage)
                acc.CukurovaTotalCount     += num(ri.CukurovaTotalCount)
                acc.CukurovaTotalTonnage   += num(ri.CukurovaTotalTonnage)
                acc.TotalCountTasimaSayisi += num(ri.TotalCountTasimaSayisi)
                acc.TotalTonnage           += num(ri.TotalTonnage)
            }

            const arr = []
            const grand = newAcc()
            this.sefers.forEach((s,_i) => {
                const group = newAcc()
                s.SubItems.forEach((si,_sii) => {
                    si.ReportItem.forEach((ri,_rii) => {
                        ri.ReportItem.forEach((rii,_riii) => {
                            arr.push({
                                GroupIsFirst: _rii == 0 && _riii == 0 && _sii == 0,
                                GroupRowSpan: s.SubItems.map(r => r.ReportItem.map(rr => rr.ReportItem.length )).reduce((s,i) => s += Number(i),0) + s.SubItems.length,
                                GroupCode:s.GroupCode,
                                GroupName:s.GroupName,
                                StokIsFirst:_rii == 0 && _riii == 0,
                                StokRowSpan: si.ReportItem.map(rr => rr.ReportItem.length).reduce((s,i) => s += Number(i),0) + 1,
                                StokKodu:si.StokKodu,
                                StokAdi:si.StokAdi,
                                Cari:rii.CariIsim,
                                Celemli:getStats('Çelemli',rii.BySubeStats),
                                Narli:getStats('Narlı',rii.BySubeStats),
                                Cukurova:getStats('Çukurova',rii.BySubeStats),
                                TasimaSayisi:rii.TasimaSayisi,
                                TasimaToplamTonaj:rii.TasimaToplamTonaj
                            })
                        })
                        arr.push({
                            Stats:true,
                            TotalCountTasimaSayisi: ri.TotalCountTasimaSayisi,
                            TotalTonnage:ri.TotalTonnage,
                            CelemliTotalCount:ri.CelemliTotalCount,
                            CelemliTotalTonnage:ri.CelemliTotalTonnage,
                            CukurovaTotalCount:ri.CukurovaTotalCount,
                            CukurovaTotalTonnage:ri.CukurovaTotalTonnage,
                            NarliTotalCount:ri.NarliTotalCount,
                            NarliTotalTonnage:ri.NarliTotalTonnage,
                        })
                        addAcc(group,ri)
                        addAcc(grand,ri)
                    })
                })
                // Grup dip toplamı (her grubun sonunda)
                arr.push({ GroupStats:true, GroupCode:s.GroupCode, GroupName:s.GroupName, ...group })
            })
            // Genel toplam (en altta)
            if(this.sefers.length){
                arr.push({ GrandStats:true, ...grand })
            }
            return arr
        },
        date:{
            get:function(){
                return [this.queryData.StartDate,this.queryData.EndDate].filter(d=>d != null)
            },
            set:function(val){
                this.queryData.StartDate = val[0] || null
                this.queryData.EndDate = val[1] || null
            }
        },
        payload(){
            return {
                ...this.queryData,
                TargetCariCodes: this.selectedTargetCaris.map(c => c.CARI_KOD),
                StockCodes: this.selectedStoks.map(s => s.Code),
            }
        },
    }
}
</script>

<style scoped>
/* Sağa-sola scroll olmadan, kompakt rapor görünümü */
.compact-report{
    font-size: 0.72rem;
    table-layout: fixed;
    width: 100%;
}
.compact-report th,
.compact-report td{
    padding: 0.2rem 0.35rem;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: anywhere;
    vertical-align: middle;
}
/* Kolon genişlikleri <colgroup> ile belirleniyor; sayısal hücreler sağa yaslı.
   Genişlik yetmezse sayı alt satıra kayar, asla taşıp kırpılmaz. */
.compact-report th.num,
.compact-report td.num{
    text-align: right;
}
</style>